import { supabase } from "~/integrations/supabase/client";

export interface CxpReconciliationFilters {
  initialDate: string; // YYYY-MM-DD — Saldo Inicial al
  finalDate: string; // YYYY-MM-DD — Saldo Final / Corte al
  companyId?: string;
}

// One row per proveedor account (2103001 Nacional, 2103002 Exterior). The report pivots these
// into Concepto rows × cuenta columns and adds a Total column client-side.
export interface CxpReconciliationRow {
  cuenta: string; // "2103001" | "2103002"
  cuenta_nombre: string;
  saldo_inicial: number;
  facturas: number;
  facturas_docs: number;
  nota_debito: number;
  nota_debito_docs: number;
  notas_credito: number;
  notas_credito_docs: number;
  pagos: number;
  pagos_docs: number;
  ajustes: number;
  saldo_contable: number;
  listado_auxiliar: number;
  diferencia: number;
}

// RPC added after the last supabase types regeneration — thin typed wrapper.
const rpcCall = supabase.rpc.bind(supabase) as unknown as <T>(
  fn: string,
  args?: Record<string, unknown>
) => Promise<{ data: T | null; error: { message: string } | null }>;

export const cxpReconciliationService = {
  async getReconciliation(
    filters: CxpReconciliationFilters
  ): Promise<CxpReconciliationRow[]> {
    const { data, error } = await rpcCall<CxpReconciliationRow[]>(
      "get_cxp_reconciliation",
      {
        p_initial_date: filters.initialDate,
        p_final_date: filters.finalDate,
        p_company_id: filters.companyId ?? null,
      }
    );
    if (error) throw new Error(error.message);
    return (data ?? []).map((r) => ({
      ...r,
      saldo_inicial: Number(r.saldo_inicial),
      facturas: Number(r.facturas),
      facturas_docs: Number(r.facturas_docs),
      nota_debito: Number(r.nota_debito),
      nota_debito_docs: Number(r.nota_debito_docs),
      notas_credito: Number(r.notas_credito),
      notas_credito_docs: Number(r.notas_credito_docs),
      pagos: Number(r.pagos),
      pagos_docs: Number(r.pagos_docs),
      ajustes: Number(r.ajustes),
      saldo_contable: Number(r.saldo_contable),
      listado_auxiliar: Number(r.listado_auxiliar),
      diferencia: Number(r.diferencia),
    }));
  },
};
